import { mapGetters } from 'vuex';

const incein = {
  computed: {
    ...mapGetters('app', ['isIncein']),
  },
};

export default incein;
